import { CREDIT_NOTE_FIELDS, INVOICE_FIELDS } from "@/modules/gst/fields";
import { CreditNotes } from "@/modules/gst/screens/CreditNotes";
import { Exports } from "@/modules/gst/screens/Exports";
import { GstSettings } from "@/modules/gst/screens/GstSettings";
import { HsnSummary } from "@/modules/gst/screens/HsnSummary";
import { InvoiceList } from "@/modules/gst/screens/InvoiceList";
import type { ModuleUi } from "@/modules/types";

/**
 * The GST module.
 *
 * Invoices and credit notes are different documents drawn from different
 * series, so each declares its own vocabulary. `hsn-summary`, `exports` and
 * `settings` are a report, a set of actions and a form rather than filtered
 * lists, so all three declare no fields and the toolbar's list controls sit
 * out.
 */
export const gstModule: ModuleUi = {
  id: "gst",
  sections: {
    invoices: { fields: INVOICE_FIELDS, screen: InvoiceList },
    "credit-notes": { fields: CREDIT_NOTE_FIELDS, screen: CreditNotes },
    "hsn-summary": { fields: [], screen: HsnSummary },
    exports: { fields: [], screen: Exports, padded: true },
    settings: { fields: [], screen: GstSettings, padded: true },
  },
};
